import React from 'react';
import { UIButton, SectionContainer } from '../../ui-system';

const selectClassName = 'h-10 rounded-xl border-0 bg-[#0b1422] px-3 text-xs text-[#d5e4f4] outline-none focus:ring-2 focus:ring-emerald-300/35';
const inputClassName = 'h-10 rounded-xl border-0 bg-[#0b1422] px-3 text-xs text-[#d5e4f4] outline-none focus:ring-2 focus:ring-emerald-300/35';

const AuditFilterBar = ({ filters, onChange, onRefresh }) => {
  const setField = (key, value) => onChange?.((prev) => ({ ...prev, [key]: value }));

  return (
    <SectionContainer className="p-3">
      <div className="grid gap-2 md:grid-cols-6">
        <select
          value={filters.entityType}
          onChange={(e) => setField('entityType', e.target.value)}
          className={selectClassName}
        >
          <option value="">Semua Entity</option>
          {['CUSTOMER','TICKET','DISPATCH','WORK_ORDER','INSTALLATION','ACTIVATION','BILLING','PAYMENT','INCIDENT','RECOVERY','ROUTE_PLAN'].map((x) => (
            <option key={x} value={x}>{x}</option>
          ))}
        </select>

        <select
          value={filters.actorType}
          onChange={(e) => setField('actorType', e.target.value)}
          className={selectClassName}
        >
          <option value="">Semua Actor</option>
          {['SYSTEM','CUSTOMER','TECHNICIAN','ADMIN'].map((x) => (
            <option key={x} value={x}>{x}</option>
          ))}
        </select>

        <select
          value={filters.actionType}
          onChange={(e) => setField('actionType', e.target.value)}
          className={selectClassName}
        >
          <option value="">Semua Action</option>
          {['CREATED','UPDATED','ASSIGNED','STATUS_CHANGED','APPROVED','REJECTED','SUBMITTED','COMPLETED','FAILED','AUTO_ASSIGNED','AUTO_RECOVERED'].map((x) => (
            <option key={x} value={x}>{x}</option>
          ))}
        </select>

        <input
          type="datetime-local"
          value={filters.dateFrom}
          onChange={(e) => setField('dateFrom', e.target.value ? new Date(e.target.value).toISOString() : '')}
          className={inputClassName}
        />

        <input
          type="datetime-local"
          value={filters.dateTo}
          onChange={(e) => setField('dateTo', e.target.value ? new Date(e.target.value).toISOString() : '')}
          className={inputClassName}
        />

        <UIButton
          type="button"
          onClick={onRefresh}
          variant="ghost"
          className="h-10"
        >
          Refresh
        </UIButton>
      </div>
    </SectionContainer>
  );
};

export default AuditFilterBar;
